import React, {useState} from 'react'
import styled from 'styled-components'
import {api} from 'lib/url'
import {ObvioEvent} from 'Event'
import {useOrganization} from 'organization/OrganizationProvider'
import Dialog from 'lib/ui/Dialog'
import Button from 'lib/ui/Button'
import Typography from '@material-ui/core/Typography'
import Grid from 'lib/ui/Grid'
import {DialogContent, DialogTitle} from '@material-ui/core'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'

export default function ArchiveEventDialog(props: {
  onClose: () => void
  visible: boolean
  event: Pick<ObvioEvent, 'id' | 'slug' | 'name'>
  onArchived: (event: {id: number}) => void
}) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const {client} = useOrganization()
  const {visible, onClose, event, onArchived} = props

  const clearError = () => setError(null)

  const onConfirm = () => {
    setLoading(true)
    setError(null)
    const url = api(`/events/${event.slug}/archive`)
    client
      .post<ObvioEvent>(url)
      .then(() => {
        onArchived(event)
        onClose()
      })
      .catch((e) => {
        setError(e.message || 'Could not archive event. Please try again.')
        setLoading(false)
      })
  }

  return (
    <Dialog open={visible} onClose={onClose} disableEnforceFocus>
      <DialogTitle>Archive event</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item md={12} xs={12}>
            <Typography>{event.name}</Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <Typography color="textSecondary">
              Archiving turns off every zoom areas/rooms, set event to offline
              and disables the event. Attendees will no longer be able to get to
              this events dashboard.
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <ErrorAlert onClose={clearError}>{error}</ErrorAlert>
          </Grid>
          <ActionsGridItem item md={12} xs={12}>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={onConfirm}
              disabled={loading}
              aria-label="confirm archive"
            >
              Archive
            </ActionButton>
            <ActionButton
              variant="outlined"
              color="primary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </ActionButton>
          </ActionsGridItem>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

const ActionButton = styled(Button)`
  margin: ${(props) => props.theme.spacing[2]};
`

const ActionsGridItem = styled(Grid)`
  padding-top: ${(props) => props.theme.spacing[4]};
`
